import template from './adpToast.html';
import controller from './adpToast.controller';
import './adpToast.less';

let adpToastComponent = {
  restrict: 'E',
  bindings: {
    hidden: "=",
  },
  transclude: true,
  template,
  controller
};

export default adpToastComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpToast/adpToast.component.js